// extracted by mini-css-extract-plugin
export var link = "hd_R";